// Path: ./src/app/pages/NotificationPage/useNotificationTableColumns.tsx
// setTableColumn.tsx

import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { useTranslation } from "react-i18next";

export const useNotificationTableColumns = () => {
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];

  const columns = [
    {
      field: "title",
      width: 500,
      headerName: `Title`,
    },
    {
      field: "body",
      width: 500,
      headerName: `Body`,
    },
    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),
    {
      field: "id",
      width: 300,
      headerName: `${t(messages["id"]())}`,
      filterable: false,
    },
  ];

  return columns;
};
